import * as React from "react";
import { forwardRef } from "react";
const SvgArrowsUpDownLine = ({
  title,
  titleId,
  ...props
}, ref) => /* @__PURE__ */ React.createElement("svg", { width: 14, height: 14, viewBox: "0 0 14 14", fill: "none", xmlns: "http://www.w3.org/2000/svg", ref, "aria-labelledby": titleId, ...props }, title ? /* @__PURE__ */ React.createElement("title", { id: titleId }, title) : null, /* @__PURE__ */ React.createElement("path", { fill: "none", d: "M4.375 11.375V2.625M6.41667 4.66667L4.375 2.625L2.33333 4.66667M9.625 2.625V11.375M11.6667 9.33333L9.625 11.375L7.58333 9.33333", stroke: "currentColor", strokeWidth: 1.60417, strokeLinecap: "round", strokeLinejoin: "round" }));
const ForwardRef = forwardRef(SvgArrowsUpDownLine);
export default ForwardRef;
